export type MediaFrame = "portrait" | "landscape" | "unknown";

export const frameFromSize = (width?: number, height?: number): MediaFrame => {
  if (!width || !height) {
    return "unknown";
  }
  return height > width ? "portrait" : "landscape";
};

export const frameClass = (frame: MediaFrame) =>
  frame === "portrait" ? "is-portrait" : frame === "landscape" ? "is-landscape" : "is-unknown";
